import { Goal } from "interfaces/Goal";
import { transformCurrency } from "utils/functions/currencyModUtil";
import { getOfferSaleMultiplierLabel } from "utils/functions/offerSaleUtil";
import { FaCheckCircle, FaRegCircle } from "react-icons/fa";
import { MdChangeCircle } from "react-icons/md";
import * as c from "./OfferModalGoal.module.css";

interface OfferModalGoalProps {
  goal: Goal;
  currencyName: string;
  index: number;
}

const OfferModalGoal = ({ goal, currencyName, index }: OfferModalGoalProps) => {
  const { id, title, description, attributionWindowMinutes, rewardIac, isCompleted, isPending } =
    goal;
  const currency = transformCurrency(currencyName, rewardIac);
  const originalCurrency =
    goal.promotion == null
      ? undefined
      : transformCurrency(currencyName, goal.promotion?.originalRewardIac!);

  const isPromotion = () => {
    return goal.promotion !== null && goal.promotion?.originalRewardIac !== goal.rewardIac;
  };

  const formatAttributionWindow = (minutes?: number): string => {
    if (minutes === undefined) {
      return "";
    }

    if (minutes >= 1440) {
      // 1 day = 1440 minutes
      const days = Math.floor(minutes / 1440);
      return `Complete in ${days} day${days > 1 ? "s" : ""} to qualify.`;
    } else if (minutes >= 60) {
      const hours = Math.floor(minutes / 60);
      return `Complete in ${hours} hour${hours > 1 ? "s" : ""} to qualify.`;
    } else {
      return `Complete in ${minutes} minute${minutes > 1 ? "s" : ""} to qualify.`;
    }
  };

  return (
    <div className={c.task}>
      <div
        className={`${c["task-content-wrapper"]} ${isCompleted && c["task-content-completed"]} ${
          isPending && c["task-content-pending"]
        }`}
      >
        <div className={c["content-wrapper-top"]}>
          {isCompleted ? (
            <FaCheckCircle color={"#249a63"} size={"20px"} />
          ) : isPending ? (
            <MdChangeCircle color={"#ffb700"} size={"22px"} />
          ) : (
            <FaRegCircle color={"#94a3b8"} size={"20px"} />
          )}
          <div className={c["task-text-wrapper"]}>
            <span className={c["text-font"]}>{title}</span>
            {isPending ? (
              <div className={c["task-text-pending"]}>
                <div className={c["task-text-pending-top"]}>
                  <span className={c["task-currency"]}>{currency}</span>
                  <span className={c["task-label"]}>In-Progress</span>
                </div>
                <div className={c["task-text-pending-bottom"]}>
                  <span>Please allow up to 7 days to credit</span>
                </div>
              </div>
            ) : isPromotion() ? (
              <div className={c["task-text-boost"]}>
                <span className={c["task-currency-line"]}>{originalCurrency}</span>
                <span className={c["task-currency-boost"]}>{currency}</span>
                <span className={c["task-boost-label"]}>
                  {getOfferSaleMultiplierLabel(goal.promotion?.multiplier!)}
                </span>
              </div>
            ) : (
              <span className={c["task-currency"]}>{currency}</span>
            )}
          </div>
        </div>
        {attributionWindowMinutes && (
          <div className={c["days-left-container"]}>
            <span>{formatAttributionWindow(attributionWindowMinutes)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default OfferModalGoal;
